/* eslint-disable */
import React from 'react';
import wrapDisplayName from 'recompose/wrapDisplayName';
import envIsProduction from '../../Support/Env/IsProduction/EnvIsProduction.support';
import ServicesContext from './Services.context';

/**
 * To ensure that each `<Component />` does not have to worry about including a `<ServicesContext.Consumer />` somewhere in their `render()` tree, we can define
 * a function that will do that for us automatically. It much the same way that we use `withRouter`, and `withStyles`, we can create our own function that takes
 * an existing `<Component />`, forwards its `prop`, then adds own `props`.
 *
 * The first and only child of `<ServicesContext.Consumer />` has to be a function. That function will be supplied the fallback value provided to
 * `React.createContext()`, in our case, our `mockServices`. This works out perfectly for us. Inside our `<Entry />` points, we define a
 * `<ServicesContext.Provider value={services} />` with our real `services`. This means, that when our app is running, the real values will be provided, yet in
 * our unit tests, the fallback value, in this case, our `mockServices` will be provided.
 *
 * So long as we don't include a `<ServicesContext.Provider />` in our unit tests, everything will work out as planned :)
 * @export
 * @param {React.Component} Component The Component to wrap
 * @returns {React.Component} The rendered `<Component />`
 */
const withServices = (Component) => {
  /**
   * Render the component
   * @param {any} props The props that were passed in to `<Component />`
   * @returns {React.Component} The rendered `<WrappedComponent />`
   */
  const WrappedComponent = (props) => (
    <ServicesContext.Consumer>{(servicesOrFallback) => <Component {...props} services={servicesOrFallback} />}</ServicesContext.Consumer>
  );
  // Update the `displayName` of the `<Component />` so that in any warnings or Error's that may be thrown, we know that the component is wrapped
  if (!envIsProduction()) {
    WrappedComponent.displayName = wrapDisplayName(Component, `WithServices`);
  }
  return WrappedComponent;
};

export default withServices;
